import { Component } from '@angular/core';
import { NavigationService } from "@shared/services/navigation-service.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { cloneDeep } from "lodash";
import { EcommerceService } from '../ecommerce.service';
import { ToastService } from '@app/shared/services/toast.service';


@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent {

  public params: any;
  public totalItems: any;
  public totalPages: any;
  public dataList: any;
  public PAGE_PATH = 'ecommerce/categories'
  public categoryId = '';
  AllList = [
    {
      value: 'ALL',
      label: 'All'

    }
  ];
  categoriesList: any[] = [];
  selectedItemId: number | null = null;
  selectedItemName: string = '';
  modalTitle: string = 'Create Category';
  selectedCategory: { name: string; nameAr: string, id: number } = {
    name: '',
    nameAr: '',
    id: -1
  };

  constructor(public service: EcommerceService,
    public navigation: NavigationService,
    public spinner: NgxSpinnerService,
    public router: Router,
    public route: ActivatedRoute,
    public toast: ToastService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.initQueryParamMap();
  }


  public initQueryParamMap() {
    this.route.queryParamMap
      .subscribe((params: any) => {
        this.params = params.params.page ? cloneDeep(params.params) : {
          page: 1,
          srt: 'date',
          srtd: 'desc',
        };
        this.getItems();
      }
      );
  }


  public getItems() {
    this.service.getCategories(this.params).subscribe((res: any) => {
      this.dataList = res.data;
      this.totalItems = res.total;
      this.totalPages = Math.ceil(parseInt(res.total.toString()) / 5);
      this.totalPages = this.totalPages == 0 ? 1 : this.totalPages;
      this.spinner.hide();

    }, error => {
      console.log(error);
      this.spinner.hide();

    });
  }

  backClick(event: any) {
    this.params.page--;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  nextClick(event: any) {
    this.params.page++;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  doSearchByEnter(val: any) {
    this.params.page = 1;
    this.params.search = val?.target?.value;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);

  }

  doSearchByKeyUp(event: any) {
    this.params.search = event.target.value;
    if (this.params.search.length > 3 && event.key !== 'Enter') {
      this.params.page = 1;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
    if (this.params.search.length === 0) {
      delete this.params.search;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
  }

  public goToDetails(category: any) {
    this.modalTitle = 'Edit Category';
    this.selectedCategory = { name: category.name, nameAr: category.nameAr, id: category.id };
  }

  createNewCategory(id: any) {
    this.modalTitle = 'Create Category';
    this.selectedCategory = { name: '', nameAr: '', id: -1 };
  }


  saveCategory(category: { name: string; nameAr: string; id: number }) {
    this.spinner.show();
    if (category.id == -1){
      this.service.createCategory(category).subscribe((res: any) => {
      this.toast.success("Category Created Successfully");
      this.getItems();
      this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      });
    }
    else{
      this.service.editCategory(category, category.id).subscribe((res: any) => {
      this.toast.success("Category Updated Successfully");
      this.getItems();
      this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      });
    }
  }

  
  openConfirmDialog(item: { id: number; name: string }) {
    this.selectedItemId = item.id;
    this.selectedItemName = item.name;
  }

  deleteItem() {
    if (this.selectedItemId !== null) {
      this.spinner.show();
        this.service.deleteCategory(this.selectedItemId).subscribe((res: any) => {
        this.toast.success("Category Deleted Successfully");
        this.getItems();
          this.spinner.hide();
        },
        error => {
          this.spinner.hide();
          console.log(error);
        });
      }
  }

}
